export default "87685346be520c1da76d3a204796603d.svg";